import React from "react";
import ScatterPlot from "./ScatterPlot";
import PlotGrid from "./PlotGrid";

export interface FeatureSelectionPlotProps {
  data: any[];
  className?: string;
}

const FeatureSelectionPlot = ({
  data,
  className = "",
}: FeatureSelectionPlotProps): React.ReactElement => {
  if (!data || data.length === 0) {
    return <p>No feature selection data available.</p>;
  }

  return (
    <PlotGrid className={className}>
      <ScatterPlot
        data={data}
        xMetric="means"
        yMetric="dispersions"
        title="Mean vs. Dispersion (Unnormalized)"
        defaultColor="#2c7bb6"
      />

      <ScatterPlot
        data={data}
        xMetric="means"
        yMetric="dispersions_norm"
        title="Mean vs. Dispersion (Normalized)"
        defaultColor="#2c7bb6"
      />
    </PlotGrid>
  );
};

export default FeatureSelectionPlot;
